import { ChevronDown, Info } from "lucide-react";
import "./quick-deposit.css";
import InnerHeader from "../../components/InnerHeader";
import Splash from "../../common/Splash";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
export default function QuickDeposit({ items, promotions, userData, transactionData, hasEWallet, usdtRate }) {
  const navigate = useNavigate();
  const [selectedPayment, setSelectedPayment] = useState("bKash");
  const [selectedChannel, setSelectedChannel] = useState("B99-CashOut");
  // const [amount, setAmount] = useState("");
  // const [activeAmount, setActiveAmount] = useState("");
  const [reminderExpanded, setReminderExpanded] = useState(true);

  const paymentMethods = [
    { id: "bKash", name: "bKash", icon: "../../images/deposit1.svg", hot: "2%" },
    { id: "nagad", name: "Nagad", icon: "../../images/deposit2.svg", hot: "5%" },
    { id: "rocket", name: "Rocket", icon: "../../images/deposit3.svg", hot: "8%" },
    { id: "upay", name: "Upay", icon: "../../images/deposit1.svg", hot: "8%" },
  ];

  const channels = {
    bKash: [
      { id: "B99-CashOut", name: "B99-CashOut", recommended: true },
      { id: "TM-CashOut", name: "TM-CashOut", recommended: false },
    ],
    nagad: [
      { id: "N99-CashOut", name: "N99-CashOut", recommended: true },
      { id: "NTM-CashOut", name: "NTM-CashOut", recommended: false },
    ],
    rocket: [
      { id: "R99-CashOut", name: "R99-CashOut", recommended: true },
      { id: "RTM-CashOut", name: "RTM-CashOut", recommended: false },
    ],
  };



  const [activeItem, setActiveItem] = useState(null);
  const [wapy, setWapy] = useState(false);
  const [activeAmount, setActiveAmount] = useState("");
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentSystems, setPaymentSystems] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const token = localStorage.getItem("token");
  const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500", "100"];
  const [selectedOption, setSelectedOption] = useState(null);
  const [pgs, setPgs] = useState([]);

  const [getotherContracts, setotherContracts] = useState([]);
  const [amountRange, setAmountRange] = useState([100, 25000]);
  const [currency, setCurrency] = useState("৳");
  const [presetAmounts, setPresetAmounts] = useState(["100", "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
  const [depositChannel, setDepositChannel] = useState(false);

  const fetchOther = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setotherContracts(data.data || []);


        } else {
          console.error('Failed to fetch user data');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };
  const fetchWay = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/wpay/check`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        },
      });

      // 👉 If HTTP status is 200 → WPay active
      if (response.status === 200) {
        setWapy(true);
      } else {
        setWapy(false);
        console.warn("WPay check failed:", response);
      }
    } catch (error) {
      console.error("Error fetching WPay check:", error);
      setWapy(false);
    }
  };


  useEffect(() => {
    fetchOther();
    fetchWay();
    let uniquePaymentMethods = [];
    const seenNames = new Set();

    if (items && items.length > 0) {
      items.forEach((item) => {
        if (item.name && !seenNames.has(item.name.toLowerCase())) {
          seenNames.add(item.name.toLowerCase());
          uniquePaymentMethods.push(item);
        }
      });
    }

    setPgs(uniquePaymentMethods);

  }, []);

  // ✅ Auto-select the first payment method
  useEffect(() => {
    if (items.length > 0) {
      setPaymentMethod(items[0]);
    }
  }, [items]);

  // ✅ Auto-select the first promotion
  useEffect(() => {
    if (promotions.length > 0) {
      setSelectedPromotion(promotions[0]);
    }
  }, [promotions]);

  // ✅ Fetch deposit channels when payment method changes
  useEffect(() => {
    console.log("eWa", hasEWallet);
    if (paymentMethod && hasEWallet === false) {
      const fetchPaymentMethodDetails = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/showpayment-menthod?name=${paymentMethod.name}`, {
            headers: { Authorization: `Bearer ${token}`, 'Origin': window.location.origin },
          });
          const data = await response.json();

          if (data?.success && data.data.length > 0) {
            setPaymentSystems(data.data);
            setSelectedOption(data.data[0]?.id || null); // ✅ Auto-select the first deposit channel
          }
        } catch (error) {
          console.error("Error fetching payment method details:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchPaymentMethodDetails();
    }
    if (hasEWallet === true) {

      setTimeout(() => {
        let _filtered = [];
        for (let i = 0; i < items.length; i++) {
          // console.log('X',items[i]?.name, paymentMethod?.name);
          if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
            _filtered.push(items[i]);
          }
        }
        setPaymentSystems(_filtered);
        setSelectedOption(_filtered[0]?.id || null);
        setIsLoading(false);
      }, 400);
    }
  }, [paymentMethod, token]);


  useEffect(() => {
    const selectedMethod = items.find((item) => item.id === selectedOption);
    if (selectedMethod?.account_type === 'USDT') {
      setAmountRange([10, 200])
      setCurrency('$');
      setPresetAmounts(["10", "20", "30", "50", "100", "150", "200"]);
      setDepositChannel(false);
    } else {
      setAmountRange([100, 25000]);
      setCurrency('৳');
      setPresetAmounts(["100", "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
      setDepositChannel(true);
    }
  }, [selectedOption, items]);

  const handleItemClick = (name) => {
    const selectedMethod = items.find((item) => item.name === name);
    if (selectedMethod) {
      setPaymentMethod(selectedMethod);
    }
    setTimeout(() => {
      let _filtered = [];
      for (let i = 0; i < items.length; i++) {
        // console.log('X', items[i]?.name, paymentMethod?.name);
        if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
          _filtered.push(items[i]);
        }
      }
      // console.log("Filtered DD", _filtered);
      setPaymentSystems(_filtered);
      setSelectedOption(_filtered[0]?.id || null);
    }, 200);
  };

  const handleSelection = (id) => {
    setSelectedOption(id);
  };

  const handleAmountClick = (amount) => {
    setActiveAmount(amount);
  };

  const handlePromotionChange = (event) => {
    const selectedId = parseInt(event.target.value);
    const selectedPromo = promotions.find((promo) => promo.id === selectedId);
    setSelectedPromotion(selectedPromo || null);
  };

  const handleSubmit = async () => {
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: 'deposit_button_click',
    //   category: 'User Deposit',
    //   action: 'Click',
    //   label: 'Deposit Button'
    // });

    // let isVerified = (userData?.session_id == '1') ? true : false;
    // if (!isVerified) {
    //   if (getotherContracts && getotherContracts.length > 0) {
    //     isVerified = getotherContracts.some(contract => contract.isverify === 1);
    //   }
    //   if (!isVerified) {
    //     setModalMessage(`<a href="/profile">Please verify your phone number first.</a>`);
    //     setShowModal(true);
    //     return;
    //   }
    // }

    // if (transactionData && transactionData.length > 0) {
    //   for (let trns of transactionData) {
    //     if (trns.action == "deposit" && trns.key === "0") {
    //       setModalMessage(`You already have a deposit request pending. Please wait for it to be processed before making another deposit.`);
    //       setShowModal(true);
    //       return;
    //     }
    //   }
    // }

    if (!activeAmount) {
      setModalMessage("Please fill in your amount.");
      setShowModal(true);
      return;
    }

    if (!paymentMethod) {
      setModalMessage("Please select a valid payment method.");
      setShowModal(true);
      return;
    }

    const selectedPaymentSystem = paymentSystems.find(item => item.id === selectedOption);
    if (!selectedPaymentSystem) {
      setModalMessage("Please select a Deposit channel.");
      setShowModal(true);
      return;
    }

    try {
      if (hasEWallet) {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ewa/request`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
              'Origin': window.location.origin,
            },
            body: JSON.stringify({
              amount: activeAmount,
              type: selectedPaymentSystem.account_type,
              provider: paymentMethod.name,
              promotion: selectedPromotion?.id || 0,
            }),
          });
          const data = await response.json();

          if (response.ok) {
            if (data?.url) {
              window.location.href = data.url;
              return;
            }
            navigate("/make-payment", {
              state: {
                amount: data?.amount ?? activeAmount,
                payment_icon: selectedPaymentSystem?.icon,
                payment_type: selectedPaymentSystem?.account_type,
                paymentMethodid: paymentMethod?.id,
                paymentMethodName: paymentMethod?.name,
                promotion: selectedPromotion?.id || null,
                transaction: data?.transaction,
                number: data?.number,
                timer: data?.timer ?? 10,
                message: data?.message
              },
            });
          } else {
            setModalMessage(data?.message || "An error occurred. Please try again.");
            setShowModal(true);
          }
          // } else {
          // }
        } catch (error) {
          let err = error?.response?.data?.message || "An error occurred. Please try again.";
          setModalMessage(err || "An error occurred. Please try again.");
          console.error("Error fetching e-wallet request:", error);
          setModalMessage("An error occurred. Please try again.");
          setShowModal(true);
        }

      }
      else if (wapy) {
        const baseUrl = `${process.env.REACT_APP_API_URL}/api/payin`;


        const params = new URLSearchParams({
          amount: activeAmount,
          method: (paymentMethod?.name || '').toUpperCase(),
        });

        if (selectedPromotion?.id) {
          params.append("promotion", selectedPromotion.id);
        }

        const url = `${baseUrl}?${params.toString()}`;


        try {
          const response = await fetch(url, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Accept": "application/json",
            },
          });

          const data = await response.json();

          window.open(data[0].data.url, "_blank");
        } catch (error) {
          console.error("Error calling PayIn API:", error);
        }
      }

      else {
        navigate("/make-payment", {
          state: {
            amount: activeAmount,
            payment_icon: selectedPaymentSystem.icon,
            payment_type: selectedPaymentSystem.account_type,
            paymentMethodid: paymentMethod.id,
            paymentMethodName: paymentMethod.name,
            promotion: selectedPromotion?.id || null,
          },
        });
      }
    } catch (error) {
      setModalMessage("An error occurred. Please try again.");
      setShowModal(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Splash onSplashComplete={() => {
        setIsLoading(false);
        // Force a re-render to ensure all event handlers are properly attached
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 100);
      }} />
    );
  }

  return (
    <div className="deposit-container">
      {/* Header */}
      {/* <div className="deposit-header">
        <button className="back-button">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <h1 className="header-title">Quick deposit</h1>
      </div> */}
      <InnerHeader title="Quick deposit" />
      {/* Form Content */}
      <div className="form-content">
        {/* Select Payment Method */}
        <div>
          <label
            className="section-title"
            onClick={() => navigate("/transaction-progress")}
          >
            Select payment
          </label>
          <div className="payment-methods">
            {pgs.map((method) => (
              <div
                className={`card-qd payment-method ${paymentMethod?.name === method.name ? "active" : ""}`}

                key={method.id}
                onClick={() => handleItemClick(method.name)}
              // checked={paymentMethod?.name === method.name}
              >
                <div className="badge-qd"><span>+</span>{selectedPromotion?.deposit_bouns ? Math.round(selectedPromotion.deposit_bouns) : 0}<span>%</span></div>

                <div className="logo-box">
                  <img
                    alt={method.name}
                    src={`${process.env.REACT_APP_API_URL}/storage/${method.icon}`}
                    loading="lazy"
                  />
                </div>

                <div className="title-qd">{method.name}</div>
              </div>

            ))}
          </div>
        </div>

        {/* Deposit Channel */}
        <div className="channel-section">
          <label className="channel-label">Deposit channel</label>
          <div className="channel-list">
            {paymentSystems?.map((channel) => {
              // Label text based on account_type (their logic)
              let displayName = channel.name;

              if (channel.account_type === "Agent") {
                displayName = "CashOut";
              } else if (
                channel.account_type === "Merchant" ||
                channel.account_type === "Marchent"
              ) {
                displayName = "Merchant";
              } else if (channel.account_type === "Personal") {
                displayName = "Send Money";
              }

              return (
                <div
                  key={channel.id}
                  className={`channel-item 
        ${selectedChannel === channel.id ? "active" : ""} 
        ${channel.recommended ? "recommended" : ""}`
                  }
                  onClick={() => {
                    setSelectedChannel(channel.id);   // your state
                    handleSelection?.(channel.id);    // their logic (safe optional)
                  }}
                >
                  <div className="channel-info">
                    <div className="channel-icon">💳</div>

                    <div>
                      <div className="channel-name">{displayName}</div>
                    </div>

                    {channel.recommended && (
                      <span className="recommended-badge">Recommended</span>
                    )}
                  </div>

                  {/* keeps your custom radio UI */}
                  <div className="channel-radio">
                    <input
                      type="radio"
                      name="depositSetting"
                      checked={selectedChannel === channel.id}
                      readOnly
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="balance-info">
          {/* Available balance: <i>{currency} {amountRange[0]} - {currency} {amountRange[1]}</i> */}
          Available balance: <span className="balance-amount">{currency} {amountRange[0]} - {currency} {amountRange[1]}</span>{" "}

        </div>
        {/* Send Money Input */}
        <div className="form-group">
          {/* <label className="form-label">Enter amount</label> */}
          <input
            type="number"
            name="amount"
            className="form-input"
            value={activeAmount}
            onChange={(e) => setActiveAmount(e.target.value)}
            placeholder="Enter amount"
          />
          {currency === '$' && <div style={{ fontSize: "14px", marginTop: '10px', textAlign: 'center' }}>1 USDT = {usdtRate} BDT/TK</div>}
        </div>

        {/* BDT Account Display */}
        {/* <div className="form-group">
          <label className="form-label">BDT</label>
          <div className="account-display">
            <span className="account-text">Account</span>
            <svg
              className="account-icon"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div> */}


        {/* Reminder Section */}
        <div className="reminder-section">
          <div
            className="reminder-header"
            onClick={() => setReminderExpanded(!reminderExpanded)}
          >
            <div className="reminder-title-wrapper">
              <Info className="info-icon" />
              <span className="reminder-title">Reminder</span>
            </div>
            <div
              className={`expand-icon ${reminderExpanded ? "expanded" : ""}`}
            >
              <ChevronDown size={20} />
            </div>
          </div>

          <div
            className={`reminder-content ${!reminderExpanded ? "hidden" : ""}`}
          >
            <ul className="reminder-list">
              <li>
                Dear all member to speed-up your deposit process, kindly follow
                these steps:
              </li>
              <li>Kindly make 5 Cash Out to the number provided.</li>
              <li>For ATM Cash Out or Cash Out of Bank</li>
              <li>Input the transaction ID.</li>
              <li>Minimum 4/5 digits.</li>
            </ul>
            <p className="reminder-note">
              Reminder: Please only make deposits to the account numbers listed
              on the deposit page. Banks can be filled at the deposit, and don't
              be persuaded to transfer directly to any other accounts or
              download any app.
            </p>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="submit-section">
        <button
          className="submit-button"
          onClick={handleSubmit}
        // disabled={!isFormValid}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
